import React, { useState, useCallback, useEffect, useMemo } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/core/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { IconButton } from '@material-ui/core';
import AutoComplateMLStyled from './AutoComplateMLStyled';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { useDispatch, useSelector } from 'dva';

var pinyin = require('pinyin');
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
function unique(arr) {
  return Array.from(new Set(arr));
}
function collectItem(arry, data, level = 1, child) {
  data.map((i) => {
    i.level = level;
    if (child) {
      const pinyinList = pinyin(i.name, {
        style: pinyin.STYLE_NORMAL, // 设置拼音风格
      });
      const result = pinyinList.reduce(function (x, y) {
        return x + y;
      });
      i.sr = `${result}+${i.name}`;
    } else {
      i.sr = i.name;
    }
    arry.push(i);
    if (i.children) {
      collectItem(arry, i.children, level + 1, 1);
    }
  });
  return arry;
}

const AutoComplateML = ({
  label,
  selectedId,
  setSelectedId,
  disabled = false,
  defaultValue,
  error,
  helperText,
  treeList,
  isFetch = true,
  customType = '',
}) => {
  const dispatch = useDispatch();
  //获取门店树形结构
  const fetchStoreTreeList = useCallback(() => {
    dispatch({
      type: customType ? customType : 'common/getStoreTreeList',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    if (!isFetch) {
      return false;
    }
    fetchStoreTreeList();
  }, [fetchStoreTreeList]);
  const list = useSelector((state) => state.common.storeTreeList);
  const storeTreeList = !isFetch ? treeList : list;
  let storeAndArea = null;
  const storeAndAreaData = useSelector(
    (state) => state.membershipReport,
  ).storeAndArea;
  if (isFetch) {
    storeAndArea = storeAndAreaData;
  }
  const storeList = useMemo(() => {
    let array = [];
    if (storeTreeList) {
      const threeArray =
        storeAndArea ??
        storeTreeList.reduce((result, currentItem) => {
          if (currentItem.children) {
            return result.concat(currentItem.children);
          }
          return result;
        }, []);
      collectItem(array, threeArray);
    }
    return array;
  }, [storeTreeList, storeAndArea]);
  // const [selectedId, setSelectedId] = useState([]);
  //关于折叠功能展示数组
  const [collapseParent, setCollapseParent] = useState([]);
  const [collapseAry, setCollapseAry] = useState([]);
  //
  const [selectedParent, setSelectedParent] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [selectValue, setSelectValue] = useState([]);

  const [removeItem, setRemoveItem] = useState([]);
  //自定义筛选方法
  // const filterOptions = (option) => option?.sr;
  const filterOptions = createFilterOptions({
    stringify: (option) => option.sr,
  });

  useEffect(() => {
    if (defaultValue?.length >= 0 && storeList.length > 0) {
      //用于替换树形结构
      const threeArray =
        storeAndArea ??
        storeTreeList.reduce((result, currentItem) => {
          if (currentItem.children) {
            return result.concat(currentItem.children);
          }
          return result;
        }, []);
      let SelectedItem = [];
      defaultValue.map((i) => {
        const selectedItem = storeList?.find((x) => x.storeNo === i);
        if (selectedItem) {
          SelectedItem.push(selectedItem);
        }
      });
      let parentArray = [];
      SelectedItem.map((b) => {
        let parent = threeArray.find((x) => x.name === b?.parentId);
        if (parent) {
          if (parentArray.indexOf(parent) < 0) {
            parentArray.push(parent);
          }
        }
      });
      let addParent = [];
      parentArray.map((b) => {
        let isAddSelectParent = true;
        b.children.map((c) => {
          if (defaultValue.indexOf(c.storeNo) < 0) {
            isAddSelectParent = false;
          }
        });
        if (isAddSelectParent) {
          addParent.push(b.name);
        }
      });
      const newParent = [...addParent];
      // console.log('newParent', newParent);

      setSelectedParent(newParent);
      setSelectValue(SelectedItem);
      setSelectedId(defaultValue);
    }
  }, [
    defaultValue,
    setSelectedId,
    setSelectValue,
    storeList,
    setSelectedParent,
    storeTreeList,
    storeAndArea,
  ]);
  useEffect(() => {
    if (inputValue) {
      // const newStoreList = storeList.map((item) => {
      //   const sr = `${item.name}+${item.pinyin}`;
      //   return { ...item, sr };
      // });
      const newSelectList = storeList.filter(
        (i) => i.sr.indexOf(inputValue) >= 0,
      );
      let parentIdAry = [];
      newSelectList.map((b) => {
        if (typeof b.parentId === 'string') {
          if (parentIdAry.indexOf(b.parentId) < 0) {
            parentIdAry.push(b.parentId);
          }
        }
      });
      setCollapseParent(parentIdAry);
      const storeIds = newSelectList.map((i) => i.storeNo);
      setCollapseAry(storeIds);
      // console.log('y', y);
    } else if (!selectedId || selectedId?.length === 0) {
      let parentIdAry = [];
      storeList.map((b) => {
        if (typeof b.parentId === 'string') {
          if (parentIdAry.indexOf(b.parentId) < 0) {
            parentIdAry.push(b.parentId);
          }
        }
      });
      // const storeIds = storeList.map((i) => i.storeNo);
      // setCollapseAry(storeIds);
      // setCollapseParent(parentIdAry);
    } else {
      let parentIdAry = [...collapseParent];
      storeList.map((b) => {
        if (
          typeof b.parentId === 'string' &&
          selectedId.indexOf(b.storeNo) >= 0
        ) {
          if (
            parentIdAry.indexOf(b.parentId) < 0 &&
            removeItem.indexOf(b.parentId) < 0
          ) {
            parentIdAry.push(b.parentId);
          }
        }
      });
      console.log({ parentIdAry, removeItem });
      setCollapseParent(parentIdAry);
      const storeIds = storeList.map((i) => {
        return i.storeNo;
      });
      setCollapseAry(storeIds);
    }
  }, [inputValue, storeList, selectedId]);

  return (
    <AutoComplateMLStyled>
      <Autocomplete
        disabled={disabled}
        size="small"
        multiple
        filterOptions={filterOptions}
        value={selectValue}
        inputValue={inputValue}
        onChange={(event, newValue, reason, detail) => {
          if (reason === 'removeOption') {
            const id = detail.option.id;
            const storeNo = detail.option.storeNo;
            const parentId = detail.option.parentId;
            const newSelectedItems = selectValue.filter((i) => i.id !== id);
            const newSelectedIds = selectedId.filter((a) => a !== storeNo);
            const newSelectedParent = selectedParent.filter(
              (b) => b !== parentId,
            );
            setSelectedParent(newSelectedParent);
            setSelectedId(newSelectedIds);
            setSelectValue(newSelectedItems);
          } else if (reason === 'clear') {
            setSelectValue([]);
            setSelectedId([]);
            setSelectedParent([]);
            setRemoveItem([]);
          }
        }}
        onInputChange={(event, newValue) => {
          setInputValue(newValue);
        }}
        id="checkboxes-tags-demo"
        options={storeList}
        disableCloseOnSelect
        sx={{ border: 'none' }}
        limitTags={1}
        getOptionLabel={(option) => option?.name}
        renderOption={(props, option) => {
          let isShow = 'flex';
          if (typeof option.parentId === 'string') {
            isShow =
              collapseAry.indexOf(option.storeNo) >= 0 &&
              collapseParent.indexOf(option.parentId) >= 0
                ? 'flex'
                : 'none';
          }
          return (
            <li
              style={{
                height: '33px',
                paddingLeft: 5,
                paddingRight: 5,
                fontSize: 12,
                display: isShow,
                alignItems: 'center',
              }}
              {...props}
            >
              {typeof option.parentId !== 'string' && (
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  onClick={() => {
                    const name = option.name;
                    const index = collapseParent.indexOf(name);
                    let newCollapseParent = [...collapseParent];
                    let newCollapseAry = [...collapseAry];
                    const threeArray =
                      storeAndArea ??
                      storeTreeList.reduce((result, currentItem) => {
                        if (currentItem.children) {
                          return result.concat(currentItem.children);
                        }
                        return result;
                      }, []);
                    const children = threeArray.find(
                      (i) => i.name === name,
                    ).children;
                    if (index >= 0) {
                      //此时属于收起
                      children.map((item) => {
                        const childIndex = newCollapseAry.indexOf(item.storeNo);
                        newCollapseAry.splice(childIndex, 1);
                      });
                      const removeData = newCollapseParent.splice(index, 1);
                      if (removeItem.indexOf(removeData[0]) < 0) {
                        setRemoveItem([...removeItem, removeData[0]]);
                      }
                    } else {
                      //此时展开
                      const rindex = removeItem.indexOf(name);
                      if (rindex >= 0) {
                        setRemoveItem(removeItem.filter((i) => i !== name));
                      }
                      newCollapseParent.push(name);
                      children.map((item) => {
                        newCollapseAry.push(item.storeNo);
                      });
                    }

                    setCollapseAry(newCollapseAry);
                    setCollapseParent(newCollapseParent);
                  }}
                >
                  <SvgIconML
                    name={
                      collapseParent.indexOf(option.name) >= 0
                        ? 'arrow-drop-down'
                        : 'arrow-drop-up'
                    }
                    size={10}
                    className="preview"
                  />
                </IconButton>
              )}

              <Checkbox
                icon={icon}
                onClick={() => {
                  const newValue = option;
                  const currentValue = newValue.name;
                  const currentParentName = newValue.name;
                  //用于替换树形结构
                  const threeArray =
                    storeAndArea ??
                    storeTreeList.reduce((result, currentItem) => {
                      if (currentItem.children) {
                        return result.concat(currentItem.children);
                      }
                      return result;
                    }, []);

                  //点击父亲
                  if (!newValue.storeNo) {
                    let index = selectedParent.indexOf(currentValue);
                    let array = threeArray.filter(
                      (i) => i.name === currentValue,
                    );
                    //如果是输入查询出来的结果
                    let childAry = array[0]?.children;
                    if (inputValue) {
                      childAry = array[0]?.children?.reduce(
                        (result, currentItem) => {
                          if (currentItem.name.indexOf(inputValue) >= 0) {
                            return result.concat(currentItem);
                          }
                          return result;
                        },
                        [],
                      );
                    }
                    let ids = childAry?.map((element) => element.storeNo);
                    let selectedItem = [];
                    console.log({ index, selectedParent, currentParentName });
                    const rindex = removeItem.indexOf(currentParentName);
                    if (rindex >= 0) {
                      setRemoveItem(
                        removeItem.filter((i) => i !== currentParentName),
                      );
                    }
                    if (index < 0) {
                      const newSelectedId = [...selectedId, ...ids];
                      const uniqueArray = unique(newSelectedId);
                      const newSelectedParent = [
                        ...selectedParent,
                        currentParentName,
                      ];
                      setSelectedParent(newSelectedParent);
                      setSelectedId(uniqueArray);
                      uniqueArray.map((i) => {
                        const item = storeList.find((a) => a.storeNo === i);
                        if (item) {
                          selectedItem.push(item);
                        }
                      });
                      setSelectValue(selectedItem);
                    } else {
                      const newSelectedParent = [...selectedParent];
                      newSelectedParent.splice(index, 1);
                      let newIds = [...selectedId];
                      [...ids].map((i) => {
                        const Index = newIds.indexOf(i);
                        newIds.splice(Index, 1);
                      });
                      newIds.map((i) => {
                        const item = storeList.find((a) => a.storeNo === i);
                        if (item) {
                          selectedItem.push(item);
                        }
                      });
                      setSelectValue(selectedItem);
                      setSelectedParent(newSelectedParent);
                      setSelectedId(newIds);
                    }
                  } else {
                    //点击孩子
                    const value = newValue.storeNo;
                    // const value = newValue.id;
                    const parentId = newValue.parentId;
                    let newids;
                    const index = selectedId.indexOf(value);
                    if (index >= 0) {
                      newids = [...selectedId];
                      newids.splice(index, 1);
                      const selectedParentId = [...selectedParent];
                      const i = selectedParent.indexOf(parentId);
                      selectedParentId.splice(i, 1);
                      setSelectedParent(selectedParentId);
                    } else {
                      let array = threeArray.filter(
                        (i) => i.name === parentId,
                      )[0].children;

                      newids = [...selectedId, value];
                      let isAddParent = true;
                      array.map((x) => {
                        if (newids.indexOf(x.storeNo) < 0) {
                          isAddParent = false;
                        }
                      });
                      isAddParent &&
                        setSelectedParent([...selectedParent, parentId]);
                    }
                    let newIdItems = [];
                    newids.map((i) => {
                      const items = storeList.find((b) => b.storeNo === i);
                      if (items) {
                        newIdItems.push(items);
                      }
                    });
                    setSelectValue(newIdItems);
                    setSelectedId(newids);
                  }
                }}
                checkedIcon={checkedIcon}
                style={{
                  height: '12px',
                  width: '12px',
                  marginRight: 8,
                  marginLeft: typeof option.parentId == 'string' && 36,
                }}
                checked={
                  typeof option.parentId === 'string'
                    ? selectedId.indexOf(option.storeNo) >= 0
                    : selectedParent.indexOf(option.name) >= 0
                }
              />
              {option.name}
            </li>
          );
        }}
        // style={{ width: 500 }}
        renderInput={(params) => (
          <TextField
            error={error}
            helperText={error && helperText}
            {...params}
            label={label}
            // placeholder="请输入门店名称"
            variant="standard"
          />
        )}
      />
    </AutoComplateMLStyled>
  );
};
export default AutoComplateML;
